import {Component, EventEmitter, Input, Output} from '@angular/core';
import { SponsorDealerModel } from '../../models/sponsor-dealer.model';

@Component({
  selector: 'app-sponsor-dealer-confirmation',
  templateUrl: './sponsor-dealer-confirmation.component.html',
  styleUrls: ['./sponsor-dealer-confirmation.component.css']
})
export class SponsorDealerConfirmationComponent  {
  @Input() model: SponsorDealerModel;
  @Output() closeEvent  = new EventEmitter<SponsorDealerModel>();

  onCancel() {
    // this.visibleChange.emit(false);\
    this.model.isSubmitted = false;
    this.model.isErrored = false;
    this.closeEvent.emit(this.model);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/sponsor-dealer-confirmation/sponsor-dealer-confirmation.component.ts